export var RfrrPageNamespace;
(function (RfrrPageNamespace) {
  RfrrPageNamespace["Infosite"] = "HOT.HIS";
  RfrrPageNamespace["Search"] = "HOT.SR";
})(RfrrPageNamespace || (RfrrPageNamespace = {}));
export const SEARCH_ID = 'searchId';